export default "<router-outlet>test</router-outlet>\n"